import { useState, useRef } from "react";
import { API_URL, isFieldError } from "../../helpers";

import InputUncontrolled from "../../components/InputUncontrolled";
import Select from "../../components/Select";
import Radios from "../../components/Radios";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

const HotelCsvForm = ({ types, dates, organizations, token }) => {
	const [report, setReport] = useState({
		generated: false,
	});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});

	const formElement = useRef(null);

	const handleUpdate = (name, value) => {
		if (name === "date") {
			const found = dates.find((element) => element.id === value);
			const array = found.val.split("-");

			setNames((names) => ({
				...names,
				[name]: value ? value : "",
				start: array[0],
				end: array[1],
			}));
		} else {
			setNames((names) => ({ ...names, [name]: value ? value : "" }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});
		setReport({ generated: false });

		const url = new URL(`${API_URL}/admin/hotelCsv`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("token", token);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});

				setReport({ ...json.report });
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleClick = () => {
		formElement.current.type.forEach((radio) => {
			radio.checked = false;
		});

		/* for single radio
      formElement.current.type.checked = false;
    */
		formElement.current.date.value = "";
		formElement.current.hotel.value = "";
		setNames({});
		setReport({ generated: false });
		setMsg({});
	};

	return (
		<>
			<p>
				Use this form to create .csv export reports for BFC hotel request data.
			</p>

			<form
				ref={formElement}
				method="post"
				action="/"
				onSubmit={(e) => handleSubmit(e)}
				className="well"
			>
				<div
					className="form-group radios two-column"
					style={{ marginTop: "0", marginBottom: "15px" }}
				>
					<Radios
						label="Select Report Type:"
						reqd={true}
						data={types}
						value={""}
						click={handleUpdate}
					/>
				</div>

				<div
					className="form-group"
					style={{
						display:
							names.type === "unpaid" ||
							names.type === "roomblock" ||
							names.type === "confirmations"
								? "none"
								: "flex",
					}}
				>
					<Select
						name="date"
						label="Date Range"
						reqd={true}
						value={""}
						options={dates}
						update={handleUpdate}
						error={isFieldError(errors, "date")}
					/>
					<div className="empty" />
				</div>

				<div
					className="form-group"
					style={{
						display:
							names.type === "unpaid" ||
							names.type === "roomblock" ||
							names.type === "confirmations"
								? "none"
								: "flex",
					}}
				>
					<InputUncontrolled
						name="start"
						label="Start Date"
						reqd={true}
						value={names.start || ""}
						update={handleUpdate}
						errors={errors}
					/>
					<InputUncontrolled
						name="end"
						label="End Date"
						reqd={true}
						value={names.end || ""}
						update={handleUpdate}
						errors={errors}
					/>
				</div>

				{/*<div
					className="form-group"
					style={{
						display: names.type === "passkey" ? "flex" : "none",
					}}
				>
					<Select
						name="hotel"
						label="Hotel"
						reqd={true}
						value={""}
						options={[
							{ id: "", name: "--" },
							{ id: "jw", name: "JW Marriott" },
						]}
						update={handleUpdate}
						error={isFieldError(errors, "hotel")}
					/>
					<div className="empty" />
				</div>*/}

				<div
					className="form-group"
					style={{
						display: names.type === "confirmations" ? "flex" : "none",
					}}
				>
					<Select
						name="registrationId"
						label="Organization Name"
						reqd={true}
						value={""}
						options={[{ id: "0", name: "--" }].concat(
							organizations.map((item) => ({ id: item.id, name: item.name }))
						)}
						update={handleUpdate}
						error={isFieldError(errors, "registrationId")}
					/>
					<div className="empty" />
				</div>

				<div className="msg-submit">
					{msg.type && <Msg data={msg} />}

					<div
						className={
							msg.type === "working" || msg.type === "success"
								? "hidden"
								: "submit-container"
						}
					>
						<Submit submit="Generate Report" />
					</div>
				</div>
				{report.generated && (
					<div className="download-container">
						<button type="button" className="naked" onClick={handleClick}>
							<i className="fa fa-times-circle-o fa-lg working" />
						</button>

						<div>
							<i className="fa fa-download fa-3x" />
							<div>
								<a href={report.url} download>
									{report.filename}
								</a>
								<span>{`${report.records} record(s) / ${report.filesize}`}</span>
							</div>
						</div>

						<small>{report.note}</small>
					</div>
				)}
			</form>
		</>
	);
};

export default HotelCsvForm;
